import {
  MILLISECONDS_PER_SECOND,
  SECONDS_PER_MINUTE,
  MINUTES_PER_HOUR,
  HOURS_PER_DAY,
  DAYS_PER_YEAR,
  MILLISECONDS_PER_MINUTE,
  MILLISECONDS_PER_HOUR,
  MILLISECONDS_PER_DAY,
  MILLISECONDS_PER_YEAR,
} from 'constants/date';

export interface DateDiffType {
  seconds: number;
  minutes: number;
  hours: number;
  days: number;
  years: number;
}

export const getDateDiff = (date1: Date, date2: Date): DateDiffType => {
  const ms: number = Math.abs(date1.valueOf() - date2.valueOf());
  const seconds = Math.floor(ms / MILLISECONDS_PER_SECOND);
  const minutes = Math.floor(ms / MILLISECONDS_PER_MINUTE);
  const hours = Math.floor(ms / MILLISECONDS_PER_HOUR);
  const days = Math.floor(ms / MILLISECONDS_PER_DAY);
  const years = Math.floor(ms / MILLISECONDS_PER_YEAR);

  return {
    seconds: seconds % SECONDS_PER_MINUTE,
    minutes: minutes % MINUTES_PER_HOUR,
    hours: hours % HOURS_PER_DAY,
    days: days % DAYS_PER_YEAR,
    years,
  };
};

export const getTimestamp = (date: Date) => {
  const timeDiff: DateDiffType = getDateDiff(new Date(), date);
  if (timeDiff.years > 0) {
    return 'over a year ago';
  }

  if (timeDiff.days > 0) {
    return `${timeDiff.days} day${timeDiff.days > 1 ? 's' : ''} ago`;
  }

  if (timeDiff.hours > 0) {
    return `${timeDiff.hours} hour${timeDiff.hours > 1 ? 's' : ''} ago`;
  }

  if (timeDiff.minutes > 0) {
    return `${timeDiff.minutes} minute${timeDiff.minutes > 1 ? 's' : ''} ago`;
  }

  return 'less than a minute ago';
};

export const hasTimeElapsedReached = (
  initialDate: Date,
  time: number,
  unit: 'second' | 'minute' | 'hour',
) => {
  if (!initialDate) return null;

  const initialDateVal = new Date(initialDate).valueOf();
  const currDateVal = new Date().valueOf();

  let divisor = 1000; // ms
  if (unit === 'second') divisor *= 1;
  else if (unit === 'minute') divisor *= 60;
  else if (unit === 'hour') divisor *= 60 * 60;

  const timeElapsed = Math.round(Math.abs((initialDateVal - currDateVal) / divisor));
  return timeElapsed >= time;
};
